import React, { useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function Editor({ onChange, value }) {
	const editor = useRef();

	const onEditorChange = () => {
		onChange({
			delta: editor.current.getEditor().getContents(),
			text: editor.current.getEditor().getText(),
			html: document.querySelector('.ql-editor').innerHTML,
		});
	};

	return (
		<div>
			<ReactQuill ref={editor} value={value?.delta} theme='snow' onChange={onEditorChange} scrollingContainer='#editor-container' placeholder="Add all your custom field like 'Terms & Conditions', 'Notes', 'Rules & Regulations' here" />
		</div>
	);
}

export default Editor;
